module.exports = __webpack_public_path__ + "media/images/iol-e8b43ba6c093897766f3013c89d18237.png";